import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class ReportesService {
  constructor(protected http: HttpClient) {}

  public get(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.serverUrl}api/reportes/get`, {});
  }

  public getCombos(i: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.serverUrl}api/reportes/getCombos`,
      {
        params: { i },
      }
    );
  }

  public getValues(defa: any): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    return this.http.post<any>(
      `${environment.serverUrl}api/reportes/getValues`,
      defa,
      options
    );
  }

  public getCSV(defa: any): Observable<HttpResponse<Blob>> {
    return this.http.post(`${environment.serverUrl}api/reportes/csv`, defa, {
      responseType: "blob",
      observe: "response",
    });
  }
  public getPdf(defa: any): Observable<HttpResponse<Blob>> {
    return this.http.post(`${environment.serverUrl}api/reportes/pdf`, defa, {
      responseType: "blob",
      observe: "response",
    });
  }
}
